import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";

// Function to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

//--- PUBLIC PANELS ---//
// ANONYMOUS
export const getAnonymousPanel = async (tracking_code) => {
  const tenant = getTenant();
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/${tracking_code}/public-messages/?manager=true`
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};

export const createAnonymousMessage = async ({ tracking_code, content }) => {
  const tenant = getTenant();
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/${tracking_code}/public-messages/`,
      { content }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};

// PUBLIC AGENT
export const getPublicExternalAgentPanel = async (tracking_code) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/${tracking_code}/internal-messages/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};

export const createPublicInternalMessage = async ({
  tracking_code,
  content,
  attachments = [],
}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/${tracking_code}/internal-messages/`,
      { content, attachments },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};


export const DeletePublicInternalMessage = async ({
  tracking_code,
  msgid,
  msgids,
}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  // Privados agrupados: borra todas las copias (msgids); público: id único (msgid)
  const data =
    Array.isArray(msgids) && msgids.length > 0
      ? { msgids: msgids.map(Number) }
      : { msgid: Number(msgid) };
  try {
    const resp = await apiCall.delete(
      `${tenant}/api/report/${tracking_code}/internal-messages/`,
      {
        data,
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};


// PRIVATE PANEL ///
export const getPrivateInternalAgentPanel = async (tracking_code) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/report/${tracking_code}/private-messages/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};

export const createPrivateInternalMessage = async ({
  tracking_code,
  content,
  selectedContacts,
  attachments = []
}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/report/${tracking_code}/private-messages/`,
      { content, selectedContacts, attachments },
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "messages"));
    console.error(error.message);
  }
};
